export default function currency (number) {
    return parseFloat(number).toLocaleString('es-MX', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })
};